/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import { Typography } from "@material-ui/core";

import { AvatarIcon } from "Components";

import styles from "./styles";

/**
 * Pseudo component
 */
function Pseudo(props) {

  const {
    userUid,
    pseudo
  } = props;

  const classes = styles();

  return (
    <div className={classes.pseudoContainer}>
      <AvatarIcon userUid={userUid}
        iconProps={{
          className: classes.avatar
        }}
      />
      <Typography className={classes.pseudo} display="inline">
        {pseudo}
      </Typography>
    </div>
  );
}

export default Pseudo;
